/**
 * Classe abstraite représentant un périphérique (capteur)
 * @module ElectrodeMuse
 */

export default class Device
{
  /** Représenter un appareil (Abstraction)
   * @constructor
   * @param {hexadecimal} aPrimaryService - Valeur hexadecimale du service primaire de l'appareil bluetooth
   */
  constructor(aPrimaryService)
  {
    if (this.constructor === Device)
    {
      throw new TypeError("Classe abstraite ne peut être instanciée");
    }

    this.primaryService = aPrimaryService;
  }

  /**Méthode abstraite de connexion d'un appareil bluetooth
   * @constructor
   * @param {hexadecimal} aPrimaryService - Valeur hexadecimale du service primaire de l'appareil bluetooth
   */
  connexion()
  {
    throw new Error("L'implémentation de cette fonction est requise.")
  }
}